import React from "react";
import { Box, Slider, Typography } from "@mui/material";

import { formatToTime } from "../../../utils/Duration";

const RecorderTimeline = ({ time, maxTime }) => {
  const showDuration = time < 270;

  return (
    <Box>
      {showDuration && (
        <Typography
          style={{
            fontSize: 12,
            position: "absolute",
            right: 4,
            bottom: "50px",
            color: "white",
          }}
        >
          {formatToTime(maxTime)}
        </Typography>
      )}

      <Slider
        disabled
        valueLabelDisplay='on'
        valueLabelFormat={formatToTime(time)}
        aria-label='timeline'
        min={0}
        max={maxTime}
        step={1}
        value={time}
        sx={{
          position: "absolute",
          padding: "0 !IMPORTANT",
          bottom: 38,
          width: "100%",

          "& .MuiSlider-track": {
            border: "none",
            zIndex: 2,
            backgroundColor: "primary.main",
          },
          "& .MuiSlider-thumb": {
            width: 24,
            height: 24,
            zIndex: 2,
            borderRadius: "50%",
            backgroundColor: "#fff",
            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
              boxShadow: "inherit",
            },
            "&:before": {
              display: "none",
            },
          },
          "& .MuiSlider-rail": {
            backgroundColor: "white !IMPORTANT",
            opacity: 0.5,
          },
          "& .MuiSlider-valueLabelOpen": { background: "none !IMPORTANT" },
          "& .MuiSlider-valueLabelLabel": {
            position: "absolute",
            bottom: -8,
            left: 2,
            fontSize: 11,
            color: "white",
          },
        }}
      />
    </Box>
  );
};
export default RecorderTimeline;
